export const AssuranceIcon: any = {
  AUTO: require('images/auto-icon.svg'),
  MRH: require('images/mrh-icon.svg'),
  EPARGN: require('images/epargn-icon.svg'),
  AddContractIcon: require('images/Shape.svg'),
  ReclamationIcon: require('images/reclamation-icon.svg'),
  TimeLineIcon: require('images/timeline-icon.svg'),
  ContractGarantie: require('images/contract-garanties-icon.svg'),
  oval: require('images/oval-icon.svg'),
  arrow: require('images/arrow-icon.svg'),
  agent: require('images/agent-icon.svg'),
  Ga: require('images/garages-agréés-icon.svg'),
  G_A: require('images/garages-agréés-icon.svg'),
  pin: require('images/pin.svg'),
  AutoMainIcon: require('images/auto-main-icon.svg'),
  offreAuto1: require('images/offres_auto_1.png'),
  offreAuto2: require('images/offres_auto_2.png'),
  offreAuto3: require('images/offres_auto_3.png'),
  offreAuto4: require('images/offres_auto_4.png'),
  checkCircle: require('images/check-circle.svg'),
  clock: require('images/clock.svg'),
  xCircle: require('images/x-circle.svg'),
  xGreyCircle: require('images/x-grey-circle.svg'),
  assitance: require('images/assitance.svg'),
  emptyBox: require('images/empty-box.svg'),
  email: require('images/email.svg'),
  arrowUp: require('images/arrow-up.svg'),
  checkedIcon: require('images/checked-icon.svg'),
  unCheckedIcon: require('images/unchecked-icon.svg'),
  Bitmap: require('images/Bitmap.svg'),
  support1: require('images/support1.svg'),
  support2: require('images/support2.svg'),
  support3: require('images/support3.svg'),
  support4: require('images/support4.svg'),
  downloadIcon: require('images/downloadIcon.svg'),
  X: require('images/x.svg'),
  house: require('images/dar.png'),
  survey: require('images/survey.svg'),
  playButton: require('images/play-button.svg'),
  whiteX: require('images/white-x.svg'),
  EmptyJournalSinitre: require('images/empty-journal.svg'),
  playVideo: require('images/play-video.png'),
  saham: require('images/logo-saham.svg'),
  callIcon: require('images/call-icon-2.svg'),
  displayIcon: require('images/displayIcon.svg'),
  MRHMainIcon: require('images/MRH-main-icon.svg'),
  EPARGNEMainIcon: require('images/Epargne-main-icon.svg'),
  HEALTHMainIcon: require('images/health-main-icon.svg'),
  OvalRed: require('images/Oval-red-icon.svg'),
  facebookIcon: require('images/facebook-icon.svg'),
  youtubeIcon: require('images/youtube-icon.svg'),
  ContractGarantieMRH: require('images/contract-garantie-MRH.svg'),
  ReclamationIconMRH: require('images/reclamation-icon-Mrh.svg'),
  headerMRH: require('images/header-mrh.png'),
  checkAddContract: require('images/check-add-contract.svg'),
  criminal: require('images/criminal.svg'),
  Fire: require('images/Fire.svg'),
  Gas: require('images/Gas.svg'),
  Leak: require('images/Leak.svg'),
  policyNumberImage: require('images/contrat.png'),
  oldMan: require('images/epargn-offer.png'),
  timeline_mrh: require('images/timeline_mrh.svg'),
  AgentCall: require('images/AgentCall.svg'),
  AgentEmail: require('images/AgentEmail.svg'),
  CallService: require('images/callIconService.svg'),
  CallServiceAuto: require('images/AgentServiceAuto.svg'),
  AgentCallAuto: require('images/AgentCallAuto.svg'),
  AgentEmailAuto: require('images/AgentEmailAuto.svg'),
  bell: require('images/bell.svg'),
  profilSetting: require('images/profil-setting.svg'),
  telInfo: require('images/tel-info.svg'),
  caretDown: require('images/caret-down.svg'),
  besoinAideIcon: require('images/Besoin-aide-icon.png'),
  reportEpargn: require('images/report_epargn.svg'),
  contractsEpargn: require('images/contracts_epargn.svg'),
  headerEpargn: require('images/Header_Epargn.png'),
  check_auto_express: require('images/marker-auto.svg'),
  garage_agree: require('images/marker-garage.svg'),
  saham_agencies: require('images/marker-agent.svg'),
  alertTriangle: require('images/alert-triangle.svg'),
  blueUser: require('images/blue-user.svg'),
  fileIcon: require('images/file-icon.svg'),
  lockIcon: require('images/lock-icon.svg'),
  messagesIcon: require('images/messages-icon.svg'),
  settingsInfo: require('images/settings-info.svg'),
  settings: require('images/settings.svg'),
  epargnContitueeIcon: require('images/epargnDH.svg'),
  tauxGarantiIcon: require('images/percentage.svg'),
  epargnValoriseeIcon: require('images/epargn.svg'),
  localiserAgentIcon: require('images/localiser-agent-icon.svg'),
  ItineraireIcon: require('images/arrow-right.svg'),
  PhoneIcon: require('images/phoneIcon.svg'),
  EmailIcon: require('images/EmailIcon.svg'),
  HoraireIcon: require('images/horaireIcon.svg'),
  logOut: require('images/log-out.svg'),
  questionFaq: require('images/question-faq.svg'),
  noNotifications: require('images/no-notification.svg'),
  autoBgFaq: require('images/Bg-faq-auto.svg'),
  expandFaq: require('images/plus-Faq.svg'),
  openExpandFaq: require('images/open-faq-icon.svg'),
  mrhBgFaq: require('images/bg-faq-mrh.svg'),
  epargnBgFaq: require('images/bg-faq-epargn.svg'),
  sinsitreIconFaq: require('images/sinistreIconFaq.svg'),
  mrhIconFaq: require('images/mrhIconFaq.svg'),
  iconFaqEpargn: require('images/iconFaqEpargn.svg'),
  alloSamu: require('images/alert.svg'),
  infoCovid: require('images/alert-circle-info.svg'),
  policeContact: require('images/police.svg'),
  autoroute: require('images/autoroute.svg'),
  pompierContact: require('images/ambulance.svg'),
  gendarmerieContact: require('images/gendarmerie.svg'),
  phoneService: require('images/callIconService.svg'),
  ServiceClientAuto: require('images/auto-main-icon.svg'),
  ServiceClientMRH: require('images/mrhIconFaq.svg'),
  globe: require('images/globe.svg'),
  contactIcon: require('images/mail.svg'),
  contractEpargn: require('images/parapluie.svg'),
  autoLogin: require('images/auto-login.svg'),
  habitationLogin: require('images/habitation-login.svg'),
  epargnLogin: require('images/epargn-login.svg'),
  santeLogin: require('images/sante-login.svg'),
  sinistreLogin: require('images/declaration-sinistre-login.svg'),
  reportLogin: require('images/report-login.svg'),
  timelineLogin: require('images/timeline-login.svg'),
  contractLogin: require('images/contract-login.svg'),
  orderLogin: require('images/order-login.svg'),
  helpIcon: require('images/help-icon.svg'),
  jpeg: require('images/jpeg.svg'),
  upload: require('images/upload.svg'),
  helpIconLightBlue: require('images/help-icon2.svg'),
  serviceAuto: require('images/services_assistance_auto.svg'),
  serviceMrh: require('images/service_assitance_mrh.svg'),
  stopWatch: require('images/stopwatch.svg'),
  fabAgent: require('images/fab-agent.svg'),
  fabMail: require('images/fab-mail.svg'),
  fabPhone: require('images/fab-phone.svg'),
  fabQuestion: require('images/fab-question.svg'),
  mrhPolicyNumberImage: require('images/mrh-policy-number.png'),
  sahamAr: require('images/saham-logo-ar.svg'),
  epargnPolicyNumberImage: require('images/epargn-policy-number.png'),
  smartBannerIcon: require('images/smart-banner-icon.png'),
  directoryOfDoctors: require('images/find-doctor.svg'),
  findAgent: require('images/pin.svg'),
  contractsAndGuaranteesAMC: require('images/contracts-and-guarantees-amc.png'),
  claimsAMC: require('images/claims-amc.svg'),
  AMCMainIcon: require('images/AMC-main-icon.svg'),
  contactAgent: require('images/contact-agent.svg'),
  clinique: require('images/partner-clinic.svg'),
  healthGlobal: require('images/Health-global.svg'),
  assure: require('images/assure.png'),
  conjoint: require('images/conjoint.png'),
  enfant: require('images/enfant.png'),
  ServiceClientSante: require('images/health-main-icon.svg'),
  ServiceClientASI: require('images/health-international-main-icon.svg'),
};
